<div class="loader-overlay">
  <div class="loader-container">
    <ng-container [ngSwitch]="loaderType">
      <!-- Angular Material Spinner -->
      <mat-spinner *ngSwitchCase="'spinner'" color="primary"></mat-spinner>

      <!-- CSS Animated Loader -->
      <div *ngSwitchCase="'css-loader'" class="custom-loader"></div>

      <!-- SVG Loader -->
      <div *ngSwitchCase="'svg-loader'" class="svg-loader">
        <svg width="120" height="120" viewBox="0 0 40 40" stroke="#ffffff">
          <circle cx="20" cy="20" r="18" fill="none" stroke-width="4" stroke-dasharray="100" stroke-linecap="round">
            <animate attributeName="stroke-dashoffset" from="100" to="0" dur="1.5s" repeatCount="indefinite" />
          </circle>
        </svg>
      </div>

      <!-- Progress Bar Loader -->
      <div *ngSwitchCase="'progress-bar'" class="progress-loader">
        <mat-progress-bar mode="indeterminate" color="blue"></mat-progress-bar>
      </div>

      <!-- Animated Cat Loader -->
      <div *ngSwitchCase="'cat-loader'" class="cat">
        <div *ngFor="let segment of [].constructor(30); let i = index" class="cat__segment"></div>
      </div>

      <!-- Default Loader -->
      <div *ngSwitchDefault class="custom-loader"></div>
    </ng-container>

    <!-- Improved Text -->
    <p class="loader-text">Processing your Data...</p>
  </div>
</div>
